var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconListen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 41,
    viewBox: "0 0 46 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5843 22.7246C44.9549 14.7515 39.7094 0.378906 23.973 0.378906H22.2944C6.55797 0.378906 1.31249 14.8564 0.683034 22.7246L0.578125 38.4611C0.578125 39.72 1.62722 40.7691 2.88614 40.7691H9.70526C13.482 40.7691 16.5244 37.7267 16.5244 33.95V29.4389C16.5244 25.6621 13.482 22.6197 9.70526 22.6197H5.08924H4.98433C5.19415 21.151 5.71869 17.4792 7.60707 13.7024C10.6494 7.61766 15.5802 4.47038 22.2944 4.47038H23.973C38.4505 4.47038 40.9683 19.4724 41.283 22.7246H41.1781H36.667C32.8903 22.7246 29.8479 25.767 29.8479 29.5438V34.0549C29.8479 37.8316 32.8903 40.874 36.667 40.874H43.4861C44.7451 40.874 45.6892 39.8249 45.6892 38.566L45.5843 22.7246Z",
    fill: "#595757"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconListen);
export default __webpack_public_path__ + "static/media/icon_listen.20a57be5bedc0fc41a7084d53a3d43ec.svg";
export { ForwardRef as ReactComponent };